import * as React from "react";
import { useField } from "react-final-form";
import { useTranslation } from "react-i18next";
import { camelize } from "humps";
import { searchCategories } from "main/javascripts/constants/SearchCategories";

// react final formのform配下でのみ使用できる
export function SearchFormMock() {
  const { t } = useTranslation(["component"]);

  const {
    input: { value: searchTypesValue },
  } = useField("search_types");

  const renderCategoryText = (category) => {
    const camelizedSearchType = camelize(category);
    if (camelizedSearchType === searchCategories.hotel) {
      return t("search.hotel");
    } else if (camelizedSearchType === searchCategories.flight) {
      return t("search.flight");
    } else if (camelizedSearchType === searchCategories.dynamicPackage) {
      return `${t("search.flight")} + ${t("search.hotel")}`;
    }
  };

  const renderTabs = () => {
    if (searchTypesValue && searchTypesValue.length > 0) {
      return searchTypesValue.map((category) => {
        return (
          <div key={category}>
            <div className="tab">{renderCategoryText(category)}</div>
          </div>
        );
      });
    } else {
      return (
        <div>
          <div className="tab"></div>
        </div>
      );
    }
  };

  return (
    <div className="mock">
      <div className="inner">
        <div className="category-tab">{renderTabs()}</div>
        <div className="form-block"></div>
      </div>
    </div>
  );
}
